import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import metadata from './PropertyInStorageDetails.metadata.json5';
import messages from './PropertyInStorageDetails.messages';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import PropertyDetailsComponent from '../subcomponents/PropertyDetails/PropertyDetailsComponent';
import FacilityConstruction from '../FacilityConstruction/FacilityConstruction';

function PropertyInStorageDetails(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('PropertyInStorageDetails');

    const modelVM = _.get(submissionVM, pathUpdated);
    const { showConfirm } = useModal();
    const translator = useTranslator();

    modelVM.value.isValidationReq = true;

    const isOther = useCallback(() => _.get(modelVM, 'propertyDetails.locRisk.stoFacFie.value') === 'Other', [modelVM])

    const deletePropertyInStorageDetails = useCallback(
        () => {
            const infoListPath = 'lobData.perLine.coverables.propertyStorageCoverable.propertyInStorage.value';
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    const getAccordianTitle = useCallback(() => {
        const storageFacilityDetails = {};

        if (_.get(modelVM, 'propertyDetails.locRisk.stoAddFie.value') !== undefined) {
            storageFacilityDetails.address = _.get(modelVM, 'propertyDetails.locRisk.stoAddFie.value');

            const citVal = _.get(modelVM, 'propertyDetails.locRisk.stoCitFie.value');

            if (citVal?.includes(',')) {
                const indexSeparator = citVal.indexOf(',');

                storageFacilityDetails.city = citVal !== undefined ? `, ${citVal.slice(0, indexSeparator)}` : '';
            } else {
                storageFacilityDetails.city = citVal !== undefined ? `, ${citVal}` : '';
            }

            storageFacilityDetails.province = _.get(modelVM, 'propertyDetails.locRisk.stoProvince.value') !== undefined
                ? `, ${_.get(modelVM, 'propertyDetails.locRisk.stoProvince.value')}` : '';
            storageFacilityDetails.postalCode = _.get(modelVM, 'propertyDetails.locRisk.stoPosCodFie.value') !== undefined
                ? `, ${_.get(modelVM, 'propertyDetails.locRisk.stoPosCodFie.value')}` : '';
        }

        return (<div className={styles.accordianTitle}>
            <p>
                {`${translator(messages.stoFacNamValue)}${_.get(modelVM, 'propertyDetails.locRisk.stoFacFie.value') === undefined ? '' : _.get(modelVM, 'propertyDetails.locRisk.stoFacFie.value')}`}
            </p>
            <p>
                {`${translator(messages.stoFacLocValue)}`} {_.get(modelVM, 'propertyDetails.locRisk.stoAddFie.value') === undefined ? '' :
                    `${storageFacilityDetails.address}${storageFacilityDetails.city}${storageFacilityDetails.province}${storageFacilityDetails.postalCode}`}
            </p>
        </div>)
    }, [modelVM, translator]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        propertyDetailsComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.propertyDetails`,
        },
        facilityConstructionComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: `${pathUpdated}.facilityCons`,
            visible: isOther()
        },
        PropertyInStorageAccordionDetails: {
            title: getAccordianTitle()
        }

    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            deletePropertyInStorageDetails
        },
        resolveComponentMap: {
            propertyDetailsComponent: PropertyDetailsComponent,
            facilityConstructionComponent: FacilityConstruction
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PropertyInStorageDetails.propTypes = wizardProps;
export default withRouter(PropertyInStorageDetails);
